import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEventContactRemindersAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        event_contact_id: requiredUuid(),
        time_before: requiredString(),
        event_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createEventContactRemindersUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEventContactRemindersAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.event_contact_reminders,
    );

export const createEventContactRemindersDeleteSchema = () =>
    createDeleteSchema();

export const createEventContactRemindersSchemas = () => ({
    add: createEventContactRemindersAddSchema(),
    update: createEventContactRemindersUpdateSchema(),
    delete: createEventContactRemindersDeleteSchema(),
});
